import axios from "axios";
import React, { useState, useEffect } from "react";
import CreaEquipoDireccionamiento from "./CreaEquipo/CreaEquipoDireccionamiento";
import Cookies from "universal-cookie";

function EquipoDireccionamiento(props) {
  const cookies = new Cookies();

  const [list, setList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5);

  // 👉 Declaramos nombreRuta al inicio
  const url = window.location.href;
  const partesURL = url.split("/");
  const nombreRuta = partesURL[partesURL.indexOf("#") + 1];

  const obtenerEquipo = () => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoDireccionamientoPorSolicitudId?SolicitudId=" +
        props.idSolicitud,
    })
      .then((Response) => {
        setList(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    obtenerEquipo();
  }, [props.idSolicitud]);

  const eliminarMiembro = (id) => {
    const confirmar = window.confirm(
      "¿Está seguro de que desea eliminar este miembro del equipo?",
    );
    if (!confirmar) return;

    axios({
      method: "delete",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: `https://suadesarrollo.azurewebsites.net/api/eliminarEquipoDireccionamientoPorId?Id=${id}`,
      data: {
        tipoAccion: "Eliminación de registro en equipo direccionamiento",
        idUsuario: cookies.get("id"),
      },
    })
      .then(() => {
        alert("Miembro eliminado correctamente.");
        obtenerEquipo();
      })
      .catch((error) => {
        console.error("Error al eliminar:", error);
        alert("Error al eliminar el miembro.");
      });
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = list.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const renderList = currentItems.map((item) => (
    <tr key={item.id}>
      <td>{item.id}</td>
      <td>{item.nombre}</td>
      <td>{item.area}</td>
      <td>{item.cargo}</td>
      <td>{item.lider}</td>
      <td>{item.antiguedad}</td>
      <td>{item.solicitudId}</td>

      {cookies.get("tipo_Usuario") == 2 &&
      nombreRuta == "ProcesoAutoevaluacion" ? (
        <td>
          <button
            className="btn btn-danger btn-sm"
            onClick={() => eliminarMiembro(item.id)}
          >
            Eliminar
          </button>
        </td>
      ) : null}
    </tr>
  ));

  return (
    <div className="test">
      <div className="container">
        <div className="text-center">
          <div className="container-fluid">
            <div className="card shadow mb-4">
              <div className="card-header py-3">
                <h6 className="m-0 font-weight-bold text-primary">
                  Equipo Direccionamiento
                </h6>
              </div>
              <div className="card-body">
                {cookies.get("tipo_Usuario") == 2 &&
                nombreRuta == "ProcesoAutoevaluacion" ? (
                  <CreaEquipoDireccionamiento
                    idSolicitud={props.idSolicitud}
                    onCreated={obtenerEquipo}
                  />
                ) : null}

                <div className="table-responsive mt-3">
                  <table
                    className="table table-bordered"
                    id="dataTable"
                    width="100%"
                    cellSpacing="0"
                  >
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>Nombre</th>
                        <th>Área</th>
                        <th>Cargo</th>
                        <th>Líder</th>
                        <th>Antiguedad</th>
                        <th>SolicitudId</th>
                        {cookies.get("tipo_Usuario") == 2 &&
                        nombreRuta == "ProcesoAutoevaluacion" ? (
                          <th>Acciones</th>
                        ) : null}
                      </tr>
                    </thead>
                    <tbody>
                      {renderList.length > 0 ? (
                        renderList
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            No hay registros disponibles.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <ul className="pagination justify-content-center">
                  {list.length > itemsPerPage &&
                    Array.from(
                      { length: Math.ceil(list.length / itemsPerPage) },
                      (_, i) => (
                        <li
                          key={i}
                          className={`page-item ${
                            currentPage === i + 1 ? "active" : ""
                          }`}
                        >
                          <button
                            onClick={() => paginate(i + 1)}
                            className="page-link"
                          >
                            {i + 1}
                          </button>
                        </li>
                      ),
                    )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EquipoDireccionamiento;
